import { connect } from "react-redux";
import { push } from "react-router-redux";
import VerbundKompressor from "./VerbundKompressor";

export default connect(state => ({
	location_path: state.router.location.pathname
}), (dispatch, own_props) => ({
	gotoCompressor: location_path => {
		let parts = location_path.split("/");
		let new_location = parts[0] + "/" + parts[1] + "/compressor/" + own_props.lindex;
		dispatch(push(new_location));
	}
}))(VerbundKompressor);
